import { type FC } from "react";
import ShiftsDashboard from "page-sections/dashboards/shifts-dashboard";

const ShiftsStatisticsDashboard: FC = () => {
  return <ShiftsDashboard />;
};

export default ShiftsStatisticsDashboard;

